import React from 'react';
import { CommandCenterDashboard } from './pages/CommandCenterDashboard';
export function App() {
  return <CommandCenterDashboard data-id="element-0" />;
}